/* QOWAA FIT — Banner cookies RGPD branché sur la Shopify Customer Privacy API.
   Le consentement passe par setTrackingConsent() → Shopify bloque réellement analytics/marketing
   selon le choix. localStorage = uniquement pour ne pas re-flasher le banner (fallback 12 mois).
   Réouverture via un lien href="#cookie-preferences" ou [data-cookie-preferences] (footer).
   GA4 : cookie_accept_all / cookie_reject_all / cookie_preferences_open (si dataLayer présent). */
(function () {
  'use strict';
  var banner, modal, cp = null;
  var LS = 'qowaa_cookie_consent';
  var YEAR = 31536000000; // 12 mois (CNIL)

  function $(s, c) { return (c || document).querySelector(s); }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }
  function dl(ev) { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: ev }); }

  function withApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(!err && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
      });
    } else { cb(null); }
  }

  function rememberLocal(consent) {
    try { localStorage.setItem(LS, JSON.stringify({ c: consent, t: Date.now() })); } catch (e) {}
  }
  function localFresh() {
    try { var s = JSON.parse(localStorage.getItem(LS)); return s && s.t && (Date.now() - s.t) < YEAR; }
    catch (e) { return false; }
  }

  function apply(consent) {
    // sale_of_data aligné sur marketing (pas de vente de données distincte côté QOWAA)
    if (cp && typeof cp.setTrackingConsent === 'function') {
      cp.setTrackingConsent({
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.preferences,
        sale_of_data: !!consent.marketing
      }, function () {});
    }
    rememberLocal(consent);
    hide(banner); hide(modal);
  }

  function shouldShow() {
    if (cp) {
      if (typeof cp.shouldShowBanner === 'function') return cp.shouldShowBanner();
      if (typeof cp.shouldShowGDPRBanner === 'function') return cp.shouldShowGDPRBanner();
      if (typeof cp.currentVisitorConsent === 'function') {
        var v = cp.currentVisitorConsent() || {};
        return !(v.analytics || v.marketing || v.preferences || v.sale_of_data);
      }
    }
    return !localFresh();
  }

  function setToggle(name, val) { var el = document.querySelector('[data-consent="' + name + '"]'); if (el) el.checked = !!val; }
  function getToggle(name) { var el = document.querySelector('[data-consent="' + name + '"]'); return el ? !!el.checked : false; }

  function prefillToggles() {
    var v = (cp && typeof cp.currentVisitorConsent === 'function') ? (cp.currentVisitorConsent() || {}) : {};
    setToggle('analytics', v.analytics === 'yes');
    setToggle('marketing', v.marketing === 'yes');
    setToggle('preferences', v.preferences === 'yes');
  }

  function openModal() { prefillToggles(); show(modal); dl('cookie_preferences_open'); }

  function onClick(e) {
    if (e.target.closest('[data-cookie-accept]')) { apply({ analytics: true, marketing: true, preferences: true }); dl('cookie_accept_all'); return; }
    if (e.target.closest('[data-cookie-reject]')) { apply({ analytics: false, marketing: false, preferences: false }); dl('cookie_reject_all'); return; }
    if (e.target.closest('[data-cookie-prefs]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-cookie-save]')) { apply({ analytics: getToggle('analytics'), marketing: getToggle('marketing'), preferences: getToggle('preferences') }); return; }
    if (e.target.closest('[data-cookie-modal-close]')) { hide(modal); return; }
    var prefsLink = e.target.closest('[data-cookie-preferences]') || (e.target.closest('a[href="#cookie-preferences"]'));
    if (prefsLink) { e.preventDefault(); openModal(); }
  }

  function init() {
    banner = $('[data-cookie-banner]'); modal = $('[data-cookie-modal]');
    document.addEventListener('click', onClick); // toujours actif (réouverture via footer)
    if (!banner) return;
    withApi(function (api) {
      cp = api;
      if (shouldShow()) show(banner);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) hide(modal); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
